<template>
    <div class="input-group ">
        <template v-if="label">
            <div class="input-group-prepend w-30 mw-auto">
            <span class="input-group-text w-100">
                {{label}}
                <span class="red--text" v-if="this.require">【必須】</span>
            </span>
            </div>
        </template>
        <div class="form-control-static pl-2 " v-for="(data, index) in uploaded_data">
            <a target="_blank" v-bind:href="getDownloadUrl(data.id)">
                {{ data.file.name }}
            </a>
        </div>

        <div class="invalid-feedback d-block">{{ error }}</div>
    </div>
</template>

<script>
    export default {
        name: "inputFileDownloadComponent",
        props: {
            label: String,
            name: String,
            id: String,
            require: {
                type: Boolean,
                default: false
            },
            url_download: String,
        },
        data() {
            return {
                uploaded_data: [],
                error: null,
            }
        },
        methods: {
            getDownloadUrl(id) {
                return this.url_download + id;
            }
        }
    }
</script>

<style scoped>

</style>